import { createFileRoute } from "@tanstack/react-router";
import { BookOpen, Sparkles } from "lucide-react";
import { RevistaQualifierForm } from "@/components/revista/RevistaQualifierForm";
import logoRevista from "@/assets/revista/logo-revista.png.asset.json";
import capaMarco from "@/assets/revista/capas/marco.webp.asset.json";
import capaAbril from "@/assets/revista/capas/abril.webp.asset.json";
import capaMaio from "@/assets/revista/capas/maio.webp.asset.json";
import capaJunho from "@/assets/revista/capas/junho.webp.asset.json";
import capaJulho from "@/assets/revista/capas/julho.webp.asset.json";
import capaAgosto from "@/assets/revista/capas/agosto.webp.asset.json";
import capaSetembro from "@/assets/revista/capas/setembro.webp.asset.json";
import capaOutubro from "@/assets/revista/capas/outubro.webp.asset.json";
import capaNovembro from "@/assets/revista/capas/novembro.webp.asset.json";
import capaFevereiro2023 from "@/assets/revista/capas/fevereiro-2023.webp.asset.json";
import capaMarco2023 from "@/assets/revista/capas/marco-2023.webp.asset.json";
import capaAbril2023 from "@/assets/revista/capas/abril-2023.webp.asset.json";
import capaMaio2023 from "@/assets/revista/capas/maio-2023.webp.asset.json";
import capaJunho2023 from "@/assets/revista/capas/junho-2023.webp.asset.json";
import capaSubstituta from "@/assets/revista/capas/capa-substituta.webp.asset.json";
import profYuri from "@/assets/revista/professores/yuri-franco.webp.asset.json";
import profIsadora from "@/assets/revista/professores/isadora-oliveira.webp.asset.json";
import profLuiz from "@/assets/revista/professores/luiz-scola.webp.asset.json";
import profAreolino from "@/assets/revista/professores/areolino-matos.jpg.asset.json";
import profAndre from "@/assets/revista/professores/andre-mendes.webp.asset.json";
import profJulio from "@/assets/revista/professores/julio-fernandes.webp.asset.json";
import profGustavo from "@/assets/revista/professores/gustavo-nakaoka.webp.asset.json";
import profAline from "@/assets/revista/professores/aline-souza.webp.asset.json";

const PROFESSORES = [
  { nome: "Yuri Franco", foto: profYuri },
  { nome: "Isadora Oliveira", foto: profIsadora },
  { nome: "Luiz Scola", foto: profLuiz },
  { nome: "Areolino Matos", foto: profAreolino },
  { nome: "André Mendes", foto: profAndre },
  { nome: "Julio Fernandes", foto: profJulio },
  { nome: "Gustavo Nakaoka", foto: profGustavo },
  { nome: "Aline Souza", foto: profAline },
];


// Intercalando capas atuais com as edições coloridas de 2023 para dar variedade visual (9 thumbs)
const CAPAS = [
  capaNovembro,
  capaFevereiro2023,
  capaOutubro,
  capaSetembro,
  capaMarco2023,
  capaAgosto,
  capaAbril2023,
  capaSubstituta,
  capaJunho,

];



export const Route = createFileRoute("/revista")({
  head: () => ({
    meta: [
      { title: "Revista Fisio em Evidência" },
      { name: "description", content: "Receba gratuitamente todas as edições da Revista Fisio em Evidência: +70 edições, +280 artigos científicos traduzidos e comentados por especialistas." },
      { property: "og:title", content: "Revista Fisio em Evidência" },
      { property: "og:description", content: "+70 edições · +280 artigos científicos traduzidos e comentados por especialistas da FEO. 100% online e gratuito." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://fisioemortopedia.com.br/revista" },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/revista" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Revista Fisio em Evidência",
          description:
            "Arquivo da Revista Fisio em Evidência: +70 edições e +280 artigos científicos traduzidos e comentados por especialistas em fisioterapia musculoesquelética.",
          url: "https://fisioemortopedia.com.br/revista",
          inLanguage: "pt-BR",
          isPartOf: { "@type": "WebSite", name: "Fisio em Ortopedia", url: "https://fisioemortopedia.com.br" },
          about: { "@type": "Thing", name: "Fisioterapia musculoesquelética baseada em evidências" },
          publisher: { "@type": "Organization", name: "Fisio em Ortopedia", url: "https://fisioemortopedia.com.br" },
        }),
      },
    ],
  }),
  component: RevistaPage,
});

function RevistaPage() {
  return (
    <main className="min-h-screen bg-white text-slate-900 antialiased">
      {/* HERO ============================================================ */}
      <section
        id="topo"
        className="relative overflow-hidden bg-[#050b26] text-white"
      >
        {/* backdrop */}
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-[#1e88ff]/30 blur-[140px]" />
          <div className="absolute top-10 right-[-140px] h-[420px] w-[420px] rounded-full bg-[#5eb4ff]/25 blur-[130px]" />
          <div
            className="absolute inset-0 opacity-[0.07]"
            style={{
              backgroundImage:
                "linear-gradient(rgba(255,255,255,.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.4) 1px, transparent 1px)",
              backgroundSize: "56px 56px",
            }}
          />
        </div>

        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 pt-10 sm:pt-14 pb-20 sm:pb-28">
          <div className="mt-12 sm:mt-16 grid gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
            {/* left */}
            <div className="text-center sm:text-left">
              <div className="flex justify-center sm:justify-start">
                <span className="inline-flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#8ec9ff] w-auto">
                  <Sparkles className="w-3.5 h-3.5 shrink-0" /> CONTEÚDO 100% GRATUITO
                </span>
              </div>

              <h1 className="mt-6 text-[38px] leading-[1.05] sm:text-5xl lg:text-[56px] font-black tracking-tight">
                Receba todas as edições da{" "}
                <span className="bg-gradient-to-r from-[#5eb4ff] via-[#1e88ff] to-[#8ec9ff] bg-clip-text text-transparent">
                  Revista Fisio em Evidência
                </span>
              </h1>

              <p className="mt-6 max-w-xl text-lg sm:text-xl text-white/70 leading-relaxed">
                Economize horas de pesquisa. Acesse resumos e análises dos estudos mais relevantes da fisioterapia ortopédica, preparados pelos professores da FEO.
              </p>

              <dl className="mt-10 grid grid-cols-3 gap-6 max-w-lg mx-auto sm:mx-0">
                <Stat n="+70" label="edições" />
                <Stat n="+280" label="artigos" />
                <Stat n="R$0" label="para você" />
              </dl>
            </div>

            {/* right — form */}
            <div className="relative">
              <div className="absolute -inset-4 rounded-[32px] bg-gradient-to-br from-[#1e88ff]/40 via-[#5eb4ff]/20 to-transparent blur-2xl" />
              <div className="relative rounded-3xl bg-white p-6 sm:p-8 shadow-2xl shadow-[#050b26]/40 ring-1 ring-black/5">
                <RevistaQualifierForm />
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* MOCKUP STRIP =================================================== */}
      <section id="sobre" className="relative bg-[#f4f7fb] px-4 sm:px-6 py-20 sm:py-28">
        <div className="mx-auto max-w-5xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.28em] text-[#2563eb]">Sobre a revista</span>
          <h2 className="mt-4 text-3xl sm:text-5xl font-black tracking-tight text-slate-900">
            Ciência filtrada, resumida e analisada para você.
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">
            Em cada edição, selecionamos 4 estudos e apresentamos seus principais achados, pontos fortes, limitações e implicações para a prática clínica.
          </p>
        </div>

        {/* real covers — acervo alinhado */}
        <div className="mx-auto mt-16 max-w-4xl">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 rounded-full border border-[#1e88ff]/20 bg-[#1e88ff]/5 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#2563eb]">
              <BookOpen className="w-3.5 h-3.5" /> Pack completo
            </span>
            <p className="mt-4 text-sm text-slate-600">
              Ao se cadastrar você recebe <strong className="text-slate-700">todas as 70 edições</strong>.&nbsp;Textos 100% em português.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-3 sm:gap-5 lg:gap-6">
            {CAPAS.map((capa, i) => (
              <MagazineCover key={i} src={capa.url} index={i} />
            ))}
          </div>

          <p className="mt-10 text-center text-sm text-slate-600">
            Todas as 70 edições disponíveis ao se cadastrar.
          </p>

        </div>



      </section>

      {/* PROFESSORES ==================================================== */}
      <section className="relative overflow-hidden bg-[#050b26] text-white px-4 sm:px-6 py-20 sm:py-28">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-[420px] w-[720px] rounded-full bg-[#1e88ff]/20 blur-[140px]" />
        </div>
        <div className="relative mx-auto max-w-6xl">
          <div className="text-center">
            <span className="text-xs font-bold uppercase tracking-[0.28em] text-[#8ec9ff]">Corpo docente</span>
            <h2 className="mt-4 text-3xl sm:text-5xl font-black tracking-tight">
              Conheça os professores por trás de cada análise
            </h2>
            <p className="mt-5 text-lg text-white/70 max-w-2xl mx-auto">
              Especialistas que selecionam, resumem e analisam os estudos de cada edição.
            </p>
          </div>

          <ul className="mt-14 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 lg:grid-cols-4">
            {PROFESSORES.map((p) => (
              <li key={p.nome} className="flex flex-col items-center text-center">
                <div className="relative w-full max-w-[200px] aspect-square overflow-hidden rounded-2xl ring-1 ring-white/10 shadow-xl shadow-[#050b26]/50">
                  <img
                    src={p.foto.url}
                    alt={`Foto de ${p.nome}, professor da FEO`}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </div>
                <p className="mt-4 text-base sm:text-lg font-bold text-[#5eb4ff]">{p.nome}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>



      {/* CTA FINAL ===================================================== */}
      <section className="relative overflow-hidden bg-[#050b26] text-white px-4 sm:px-6 py-20 sm:py-24">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 h-80 w-[640px] rounded-full bg-[#1e88ff]/30 blur-[120px]" />
        </div>
        <div className="relative mx-auto max-w-3xl text-center space-y-6">
          <img loading="lazy" decoding="async" src={logoRevista.url} alt="Revista Fisio em Evidência" className="mx-auto h-24 sm:h-32 w-auto" />
          <h2 className="text-3xl sm:text-4xl font-black tracking-tight">
            Receba&nbsp;agora mesmo.
          </h2>
          <p className="text-white/70 text-lg">
            70 edições gratuitas produzidas ao longo dos últimos anos pela&nbsp; FEO.
          </p>
          <a
            href="#topo"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
            className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#1e88ff] to-[#5eb4ff] text-white font-bold px-9 py-4 shadow-xl shadow-[#1e88ff]/30 hover:shadow-2xl hover:shadow-[#1e88ff]/40 transition"
          >
            Quero acessar gratuitamente →
          </a>
        </div>
      </section>

      <footer className="bg-[#02061a] text-white/50 text-center text-sm py-8 px-4">
        © {new Date().getFullYear()} Portal Fisio em Ortopedia · Todos os direitos reservados
      </footer>
    </main>
  );
}

function Stat({ n, label }: { n: string; label: string }) {
  return (
    <div>
      <dt className="text-3xl sm:text-4xl font-black text-white">{n}</dt>
      <dd className="mt-1 text-xs uppercase tracking-[0.22em] text-white/50">{label}</dd>
    </div>
  );
}


function MagazineCover({ src, index }: { src: string; index: number }) {
  return (
    <div className="group relative w-full aspect-[3/4] overflow-hidden rounded-lg bg-slate-900 shadow-[0_18px_40px_-14px_rgba(5,11,38,0.35)] ring-1 ring-slate-900/10 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_28px_50px_-16px_rgba(5,11,38,0.5)]">
      {/* spine */}
      <div className="absolute inset-y-0 left-0 z-10 w-[6px] bg-gradient-to-r from-black/50 via-black/20 to-transparent" />
      {/* subtle top edge highlight */}
      <div className="absolute top-0 inset-x-0 z-10 h-[1px] bg-white/20" />
      <img src={src} alt={`Capa da edição ${index + 1} da Revista Fisio em Evidência`} className="h-full w-full object-cover" loading="lazy" />
    </div>
  );
}


